import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Phone, ShieldAlert } from "lucide-react";

/**
 * Cadena de contactos de escalamiento para el SOS — complementa (no
 * reemplaza) el ruteo automático al supervisor del objetivo. Lista ordenada
 * con botón "Llamar" en cada uno, para escalar si el primero no responde.
 * variant: "light" (tarjetas admin/supervisor) | "dark" (banners con fondo de color).
 */
export function EscalationChain({ variant = "light" }) {
  const [contacts, setContacts] = useState(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/sos/escalation-contacts"); setContacts(data); }
      catch { setContacts([]); }
    })();
  }, []);

  if (contacts && contacts.length === 0) return null;
  const dark = variant === "dark";

  return (
    <div
      data-testid="escalation-chain"
      style={{
        background: dark ? "rgba(255,255,255,0.10)" : "var(--invict-bone-2)",
        border: dark ? "1px dashed rgba(255,255,255,0.35)" : "1px solid var(--invict-bone-3)",
        borderRadius: 4, padding: "10px 12px", marginTop: dark ? 12 : 0, marginBottom: dark ? 0 : 16,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
        <ShieldAlert size={12} style={{ color: dark ? "#FFFBF4" : "#BF3437" }} />
        <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase", color: dark ? "rgba(255,251,244,0.85)" : "var(--invict-text-muted)" }}>
          Cadena de escalamiento
        </div>
      </div>
      {contacts == null ? (
        <div className="skel" style={{ height: 30 }} />
      ) : (
        <div style={{ display: "flex", gap: 6, overflowX: "auto", paddingBottom: 2 }}>
          {contacts.map((c, i) => {
            const clean = (c.phone || "").replace(/[^\d+]/g, "");
            return (
              <a
                key={c.id}
                href={clean ? `tel:${clean}` : undefined}
                data-testid={`escalation-call-${c.id}`}
                title={c.phone || "Sin teléfono"}
                style={{
                  display: "flex", alignItems: "center", gap: 5, flexShrink: 0,
                  padding: "6px 10px", borderRadius: 16, textDecoration: "none",
                  background: dark ? "rgba(255,255,255,0.14)" : "#fff",
                  border: dark ? "1px solid rgba(255,255,255,0.25)" : "1px solid var(--invict-bone-3)",
                  color: dark ? "#FFFBF4" : "#0A0A0A", fontSize: 11, fontWeight: 700,
                  whiteSpace: "nowrap", opacity: clean ? 1 : 0.5, cursor: clean ? "pointer" : "default",
                }}
              >
                <span style={{ color: dark ? "#FFD9DA" : "#BF3437", fontWeight: 900 }}>{i + 1}.</span>
                {c.name}
                <Phone size={10} />
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}
